import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'theme/color-palette';
const { GREY, BLACK, WHITE, ERROR, DISABLED, LIGHT_GREY, WARNING_COLOR, WARNING_TEXT_COLOR } =
	colors;
import { Bogle_Medium, Bogle_Regular } from 'constants/constant';

const spaceBetweenValue = 'space-between';
const borderStyle = '4px !important';
const reportSettingStyles = makeStyles((theme) => ({
	containerHeight: {
		height: '100%',
		paddingTop: 112
	},
	footerHeight: {
		width: '100vw',
		padding: '16px 0',
		display: 'flex',
		position: 'fixed',
		bottom: 0,
		justifyContent: 'center',
		backgroundColor: WHITE,
		boxShadow: `0px -1px 3px ${LIGHT_GREY}`
	},
	panel: {
		display: 'flex',
		justifyContent: 'center'
	},
	appBar: {
		zIndex: theme.zIndex.drawer + 1,
		margin: 0,
		padding: 0,
		boxShadow: `0px 0px 0px 0px`
	},
	toolbar: {
		display: 'flex',
		justifyContent: spaceBetweenValue,
		padding: '0px 24px'
	},
	fieldContainer: {
		padding: '8px 16px'
	},
	fieldContainerTrimBottom: {
		padding: '0px 16px 0px 16px'
	},
	radioContainer: {
		flexDirection: 'row',
		justifyContent: 'flex-start',
		flexWrap: 'nowrap'
	},
	errorContainer: {
		padding: '0px 16px'
	},
	dateContainer: {
		display: 'block'
	},
	datePanel: {
		padding: '16px'
	},
	dateTimeField: {
		width: '100%'
	},
	timeField: {
		width: '50%'
	},
	timeQuaterField: {
		width: '25%'
	},
	dateField: {
		width: (P) => (P.isSmallScreen ? 100 : 113),
		marginRight: '8px'
	},
	labelMonth: {
		width: '150px'
	},
	weeks: {
		width: (P) => (P.isSmallScreen ? 70 : 108)
	},
	space: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start'
	},
	tooltip: {
		maxWidth: 208,
		padding: 16,
		fontFamily: Bogle_Regular,
		color: WHITE,
		fontSize: '14px',
		textWrap: 'inherit'
	},
	spaceBetween: {
		display: 'flex',
		justifyContent: spaceBetweenValue,
		alignItems: 'center'
	},
	text: {
		fontFamily: Bogle_Regular,
		fontSize: (P) => (P.isSmallScreen ? '14px' : '16px')
	},
	black: {
		color: 'black'
	},
	fontStyleOne: {
		fontFamily: Bogle_Medium,
		fontSize: '14px',
		color: `${BLACK} !important`
	},
	fontStyleTwo: {
		fontFamily: Bogle_Regular,
		fontSize: '14px',
		color: GREY,
		whiteSpace: 'pre'
	},
	headerFont: {
		fontFamily: 'Bogle-Light',
		fontSize: '24px',
		color: BLACK,
		flex: 1,
		textAlign: 'center'
	},
	radio: {
		minWidth: '120px',
		width: 'auto'
	},
	create: {
		borderRadius: '50px',
		fontFamily: Bogle_Medium,
		width: (P) => (P.isSmallScreen ? '328px' : '168px'),
		textTransform: 'capitalize',
		'&:disabled': {
			color: WHITE,
			backgroundColor: DISABLED
		}
	},
	select: {
		fontFamily: Bogle_Regular,
		fontSize: '16px',
		marginRight: '8px'
	},
	menuPaper: {
		maxHeight: '254px'
	},
	menuItem: {
		height: '48px',
		'&:hover': {
			background: '#EBE8F3'
		}
	},
	radioText: {
		display: 'inline-flex',
		fontFamily: Bogle_Regular,
		fontSize: '16px',
		color: BLACK
	},
	radioWarning: {
		display: 'inline-flex',
		width: '200px',
		fontFamily: Bogle_Regular,
		fontSize: '16px',
		marginLeft: '4px',
		color: ERROR
	},
	radioLabelBox: {
		minWidth: '80px',
		display: 'flex',
		justifyContent: spaceBetweenValue
	},
	reportNameError: {
		display: 'flex',
		alignItems: 'center',
		color: ERROR
	},
	infoIcon: {
		width: '14px',
		color: ERROR
	},
	infoIconNormalBtn: {
		'&:hover': {
			backgroundColor: WHITE
		}
	},
	infoIconNormal: {
		color: GREY,
		width: '14px',
		'&:hover': {
			backgroundColor: WHITE
		}
	},
	errorFont: {
		fontFamily: Bogle_Medium,
		fontSize: '14px',
		color: ERROR,
		marginRight: '8px'
	},
	radioOnce: {
		borderTopLeftRadius: borderStyle,
		borderBottomLeftRadius: borderStyle
	},
	radioContinuous: {
		borderTopRightRadius: borderStyle,
		borderBottomRightRadius: borderStyle
	},
	warnMsg: {
		margin: '8px 16px',
		background: '#f9f9f9',
		padding: 8,
		borderRadius: 2,
		fontSize: 14,
		color: `${WARNING_TEXT_COLOR} !important`,
		'&.MuiAlert-icon': {
			color: `${WARNING_TEXT_COLOR} !important`
		},
		'&.MuiAlert-outlinedError': {
			borderLeftWidth: borderStyle,
			backgroundColor: WARNING_COLOR
		}
	},
	checkMarkIcon: {
		fontSize: '14px',
		color: GREY
	},
	radioTooltip: {
		top: '-15px',
		left: 0,
		width: '230px',
		fontWeight: 700,
		padding: '8px'
	},
	radioWeekendTooltip: {
		top: '-15px',
		left: '10px',
		width: '230px',
		fontWeight: 700,
		padding: '8px',
		position: 'relative',
		display: 'flex',
		pointerEvents: 'auto'
	},
	arrow: {
		left: '3px !important'
	}
}));

export default reportSettingStyles;
